export type FlowRemixPromptMeta = {
  brandName: string
  emailCount: number
}

/** The signed-out remix box's placeholder: what it remixes, in one line. */
export function buildFlowRemixPlaceholder(meta: FlowRemixPromptMeta): string {
  return `Remix this ${meta.emailCount}-email ${meta.brandName} flow for your brand — add your tone, offer or audience…`
}
